import type { UnionTypeLibelle } from "@/features/domaine/types/techniques"

export const ContratAvenantGroup = [
  'ContratInitial',
  'SuccessionContrats',
  'Avenant',
] as const

export type ContratAvenantGroup = typeof ContratAvenantGroup[number]

export const ContratAvenantGroupLibelle: UnionTypeLibelle<ContratAvenantGroup> = {
  ContratInitial: 'Contrat initial',
  SuccessionContrats: 'Succession de contrats',
  Avenant: 'Avenant : modification des conditions du contrat',
} as const
